import { Product } from "../types";
import { Drawer, DrawerContent } from "@/components/ui/drawer";
import VariantSelector from "./variant-selector";

export default function VariantSelectorDrawer({
  product,
  open,
  toggle,
}: {
  product: Product;
  open: boolean;
  toggle: () => void;
}) {
  return (
    <Drawer open={open} onClose={() => toggle(false)}>
      <DrawerContent onClose={() => toggle(false)}>
        <div className="hp-mx-auto hp-w-full hp-max-w-md">
          <div className="hp-p-4 hp-pb-0">
            <div className="no-scrollbar hp-overflow-y-auto">
              <VariantSelector product={product} />
            </div>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
  return;
}
